<template>
  <v-container fill-height container--fluid >
      <v-row>
          <v-col cols="12">
              <v-breadcrumbs
              :items="breadCrumbsItems"
                divider=">"
                ></v-breadcrumbs>
          </v-col>
      </v-row>
      <speed-stages :filterUser="filterUser" />
  </v-container>
</template>
<script>
import { mapState } from 'vuex';
import userAPIs from '../User/userAPIs';
import SpeedStages from '../DashboardComponents/SpeedStages'
import config from '@/config';

export default {
  name: 'Speed',
  components: {
    SpeedStages
  },
  data() {
    return {
      breadCrumbsItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/co/dashboard'
        },
        {
          text: 'Speed',
          disabled: true,
          href: ''
        }
      ],
      filterUser: []
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserRole: function() {
      return this.user.role;
    },
    currentUserID: function() {
      return this.user.id;
    }
  },
  async mounted() {
    let response
    // Get all CO user
    response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
    if (response) {
      this.filterUser = response.users.map(user => {
        user.name = `${user.firstName} ${user.lastName}`
        return user
      })
      this.filterUser.unshift({id: '', name: 'All Team'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// speed.vue?554d0003